/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingPayoutConfig = {
  loadingHolderGroup: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Retrieving your',
    titleBoldText: 'events list...',
    description: 'This might take few seconds, Please wait !',
  },
  loadingAddGroup: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Adding new',
    titleBoldText: '${holder_group}...',
    description: 'This might take few seconds, Please wait !',
  },
  usersEmpty: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/resting_black.png',
    titleNormalText: 'No Active events',
    titleBoldText: 'found !',
    description: 'All active events will be listed here.',
  },
  eventListEmpty: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/resting_black.png',
    titleNormalText: 'No tropical cyclone has occurred',
    titleBoldText: '...',
    description: '',
  },
};
